import { SearchAdapter, SuggestionsRequest } from '@empathy/search-adapter';
import { container } from '../../../container';
import { DEPENDENCIES } from '../../../container/dependencies.const';
import { EmpathizeState, EmpathyXConfig } from '../../../models';
import { catchAdapterError } from '../../../utils';
import { GETTERS_KEYS } from '../../store.const';
import { EMPATHIZE_ACTIONS_KEYS } from '../empathize.const';
import { EmpathizeAction, EmpathizeContext } from '../empathize.interfaces';

export class GetTermSuggestionsAction implements EmpathizeAction {

  actions = {
    [EMPATHIZE_ACTIONS_KEYS.getTermSuggestions]: (context: EmpathizeContext):
      Promise<Partial<EmpathizeState>> => {
      if (context.rootState.core.inputQuery.trim()) {
        const platformAdapter = container.get<SearchAdapter>(DEPENDENCIES.Adapter);
        return platformAdapter.getSuggestions(this.getEmpathizeRequest(context), { requestId: 'term-suggestions' })
          .then(response => ({ termSuggestions: response.suggestions } as Partial<EmpathizeState>))
          .catch(catchAdapterError('Term suggestions', { termSuggestions: [] }));
      } else {
        return Promise.resolve({ termSuggestions: [] } as EmpathizeState);
      }
    }
  };

  private getEmpathizeRequest({ rootState, rootGetters }: EmpathizeContext): SuggestionsRequest {
    const { termSuggestions }: EmpathyXConfig = rootGetters[GETTERS_KEYS.config.config];
    return {
      query: rootState.core.inputQuery.trim(),
      relatedTags: rootGetters[GETTERS_KEYS.querySignals.selectedRelatedTags],
      rows: termSuggestions.size
    };
  }
}
